import Step2y3 from './Step2y3'

export default Step2y3